/** Bộ mascot dùng chung (ảnh ở /public/mascots) + màu/emoji dự phòng. */
export const MASCOTS: Record<string, { fallback: string; emoji: string }> = {
  sprout: { fallback: "from-teal-300 to-emerald-500", emoji: "🌱" },
  soccer: { fallback: "from-sky-300 to-blue-500", emoji: "⚽" },
  scientist: { fallback: "from-violet-300 to-purple-500", emoji: "🔬" },
  painter: { fallback: "from-orange-300 to-amber-500", emoji: "🎨" },
  music: { fallback: "from-lime-300 to-green-500", emoji: "🎧" },
  student: { fallback: "from-cyan-300 to-teal-500", emoji: "🎒" },
  star: { fallback: "from-yellow-300 to-amber-400", emoji: "⭐" },
  pencil: { fallback: "from-cyan-300 to-sky-500", emoji: "✏️" },
  book: { fallback: "from-blue-400 to-indigo-500", emoji: "📖" },
  heart: { fallback: "from-orange-300 to-rose-400", emoji: "💛" },
  jump: { fallback: "from-lime-300 to-green-500", emoji: "🎉" },
};

export const MASCOT_NAMES = Object.keys(MASCOTS);

/** Chọn 1 mascot ổn định theo seed (id học sinh) để mỗi em có mascot cố định. */
export function pickMascot(seed: string): string {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return MASCOT_NAMES[h % MASCOT_NAMES.length]!;
}
